<template>
    <el-container class="healthy page-x" direction="vertical">
        <drag-dialog title="电话医生服务详情" v-model="dialogVisible">
            <div class="dialog-list">
                <div class="title">基本信息</div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">姓名：</div>
                    <div class="dialog-list-text">{{ dialogData.name }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">手机号：</div>
                    <div class="dialog-list-text">{{ dialogData.mobile }}</div>
                </div>
                <div class="title">咨询记录</div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">咨询时间：</div>
                    <div class="dialog-list-text">{{ dialogData.consultTime }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">咨询分类：</div>
                    <div class="dialog-list-text">{{ dialogData.consultType }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">分科：</div>
                    <div class="dialog-list-text">{{ dialogData.department }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">主诉：</div>
                    <div class="dialog-list-text">{{ dialogData.demand }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">预评估：</div>
                    <div class="dialog-list-text">{{ dialogData.preEvaluation }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">总结：</div>
                    <div class="dialog-list-text">{{ dialogData.doctorConclusion }}</div>
                </div>
                <div class="title">服务评价</div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">用户评价：</div>
                    <div class="dialog-list-text">{{ dialogData.userEvaluation }}</div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">返回</el-button>
            </span>
        </drag-dialog>
    </el-container>
</template>

<script>
import dragDialog from "@/components/health/dragDialog.vue";
import { cardType, orderState, relation } from "@/assets/js/options";
export default {
    name: "healthy",
    components: { dragDialog },
    data() {
        return {
            cardType, // 证件类型list
            orderState, // 订单状态list
            relation, // 与权益人关系list
            // table表格
            loading: false,
            // 弹窗
            dialogVisible: false, // 弹窗visible
            dialogData: {}, // 弹窗中的数据
        };
    },
    methods: {
        /**
         * 显示弹窗
         */
        async showDetail(id) {
            // 清空状态
            this.dialogData = {}
            this.historicalTrack = []
            this.dialogVisible = true;
            // 请求
            let res = await this.axios.get(this.getApiUrl("callDoctorOrderInfo"), {
                params: { id },
            });
            this.dialogData = res?.data || {};
            console.log(this.dialogData)
        }
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/color.scss";

.dialog-list {
    .title {
        height: 30px;
        line-height: 30px;
        margin-bottom: 20px;
        font-weight: bold;
        padding-left: 20px;
        margin-top: 18px;
        position: relative;

        &::before {
            content: "";
            display: block;
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 8px;
            background-color: $theme;
        }
    }

    .dialog-list-box {
        padding-bottom: 10px;
        display: flex;

        .dialog-list-title {
            padding-left: 20px;
            width: 80px;
            white-space: nowrap;
            text-align: right;
        }

        .dialog-list-text {
            flex: 1;
        }
    }
}
</style>